import React from "react";
import PortalCard from "./PortalCard";
import { PortalButton } from "./PortalButton";
import useBackedCampaigns from "../../hooks/useBackedCampaigns";
import fundPlaceholder from "../../assets/images/fund-placeholder.png";


export default function BackedCampaignsWidget() {
  const { items, loading, totalBacked, latestBacked } = useBackedCampaigns();

  if (loading) {
    return (
      <PortalCard
        title="Your Campaigns"
        subtitle="Loading your backed projects..."
      >
        <p className="portal-muted">Checking your crowdfunding activity…</p>
      </PortalCard>
    );
  }

if (!items.length) {
  return (
    <PortalCard
      title="Your Campaigns"
      subtitle="Backed campaigns will appear here."
    >
      <div className="portal-stack">

        <p className="portal-muted" style={{ margin: 0 }}>
          Support creator-owned projects, track rewards, and follow campaign updates from your personalized portal.
        </p>

        <PortalButton onClick={() => (window.location.href = "/fund")}>
          Browse Campaigns
        </PortalButton>
      </div>
    </PortalCard>
  );
}

  return (
    <PortalCard
      title="Your Campaigns"
      subtitle="Stay connected to the projects you've supported."
    >
      <div className="portal-stack">
        <div className="portal-stat">
          <span className="portal-stat__value">{totalBacked}</span>
          <span className="portal-stat__label">
            {totalBacked === 1 ? "campaign backed" : "campaigns backed"}
          </span>
        </div>

        {latestBacked ? (
          <div>
            <p className="portal-soft" style={{ margin: 0 }}>
              Latest backed project
            </p>
            <p
              style={{
                margin: "0.25rem 0 0 0",
                color: "#114c96",
                fontWeight: 700,
              }}
            >
              {latestBacked.projectTitle || "Untitled Project"}
            </p>

            {latestBacked.rewardTitle ? (
              <p className="portal-muted" style={{ margin: "0.35rem 0 0 0" }}>
                Reward: {latestBacked.rewardTitle}
              </p>
            ) : null}
          </div>
        ) : null}

        <PortalButton onClick={() => (window.location.href = "/fund/backer")}>
          View My Backed Projects
        </PortalButton>
      </div>
    </PortalCard>
  );
}

const contentStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

const textStyle = {
  margin: 0,
  color: "#d0d0d0",
  lineHeight: 1.5,
};

const primaryLinkStyle = {
  display: "inline-block",
  textDecoration: "none",
  backgroundColor: "#61dafb",
  color: "#111",
  fontWeight: 700,
  padding: "0.65rem 0.9rem",
  borderRadius: "10px",
  width: "fit-content",
};